export default ['ru', 'ua'];
